import { TimeOffAllocationFormat, TimeOffTypeCode } from '../types/time-off';

export const TIME_OFF_TYPE_LABEL_KEY: Record<TimeOffTypeCode, string> = {
  [TimeOffTypeCode.PAID_VACATION]: 'pages.timeOff.types.paidVacation',
  [TimeOffTypeCode.PUBLIC_HOLIDAY]: 'pages.timeOff.types.publicHoliday',
  [TimeOffTypeCode.SICK_LEAVE]: 'pages.timeOff.types.sickLeave',
  [TimeOffTypeCode.UNPAID_TIME_OFF]: 'pages.timeOff.types.unpaidTimeOff',
};

export const TIME_OFF_FORMAT_LABEL_KEY: Record<TimeOffAllocationFormat, string> = {
  [TimeOffAllocationFormat.Yearly]: 'pages.timeOff.format.yearly',
  [TimeOffAllocationFormat.Monthly]: 'pages.timeOff.format.monthly',
};
